import React from "react";
import { useTypewriter } from "@/shared/lib/useTypewriter";
import { cn } from "@/shared/utils/shadcn";

interface TypewriterTextProps {
  text: string | undefined;
  className?: string;
}

/**
 * Renders text with a typewriter type-in and a smooth fade-out on change.
 * A blinking cursor appears while typing.
 */
export function TypewriterText({ text, className }: TypewriterTextProps) {
  const { displayed, phase } = useTypewriter(text);

  if (!displayed && phase === "idle") return null;

  return (
    <p
      className={cn(
        "text-gray-500 text-sm transition-opacity duration-300",
        phase === "fading-out" ? "opacity-0" : "opacity-100",
        className
      )}
      aria-live="polite"
    >
      {displayed}
      <span
        className={cn(
          "inline-block w-[2px] h-[1em] bg-gray-400 align-middle ml-0.5",
          phase === "typing" ? "animate-blink" : "opacity-0"
        )}
      />
    </p>
  );
}
